import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { AffectedTrip } from '../components/deviation-affected-trip/deviation-affected-trip';
import { FormControl } from '@angular/forms';
import { FormSelectOption } from '../components/form-select/interfaces/form-select-option';
import { ActivityPoint, Vehicle } from '@modules/shared/models';
import { ActivityPointListItem } from '@components/vehicle/vehicle-trip-info/activity-point-list-item';

@Injectable({ providedIn: "root" })
export class TrafficDeviationTripService {
  private readonly _vehicleAndactivityPointListItemObject$ = new BehaviorSubject<Readonly<{ 
    vehicle: Vehicle, 
    activityPointListItem: ReadonlyArray<ActivityPointListItem>
  }>>(undefined);
  private readonly _connectionVehicleAndactivityPointListItemObject$ = new BehaviorSubject<Readonly<{ 
    vehicle: Vehicle, 
    activityPointListItem: ReadonlyArray<ActivityPointListItem>
  }>>(undefined);
  private readonly _selectedTrip$: BehaviorSubject<AffectedTrip> = new BehaviorSubject(null);
  private readonly _selectedConnection$: BehaviorSubject<AffectedTrip> = new BehaviorSubject(null); 
  private readonly _isConnectionFlow$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly _transportAuthorityOptions$ : BehaviorSubject<ReadonlyArray<FormSelectOption>> = new BehaviorSubject<ReadonlyArray<FormSelectOption>>([
    { text: 'SL', value: '1', selected: true },
    // should not be able choose Waxholmsbolaget since the traffic planers have not send in any
    // passes we can cancel.
    // { text: 'Waxholmsbolaget', value: '8', selected: false }, 
  ]);
  private readonly _internalConnectionPointCallOptions$: BehaviorSubject<ReadonlyArray<FormSelectOption>> = new BehaviorSubject<ReadonlyArray<FormSelectOption>>(undefined);
  private readonly _externalConnectionPointCallOptions$: BehaviorSubject<ReadonlyArray<FormSelectOption>> = new BehaviorSubject<ReadonlyArray<FormSelectOption>>([
    { text: "Vaxholm A", value: "75003", selected: true },
    { text: "Vaxholm B", value: "75004", selected: false },
  ]);

  public readonly vehicleAndactivityPointListItemObject$ = this._vehicleAndactivityPointListItemObject$.asObservable();
  public readonly connectionVehicleAndactivityPointListItemObject$ = this._connectionVehicleAndactivityPointListItemObject$.asObservable();
  public readonly selectedTrip$ = this._selectedTrip$.asObservable();
  public readonly selectedConnection$ = this._selectedConnection$.asObservable();
  public readonly isConnectionFlow$ = this._isConnectionFlow$.asObservable();

  public readonly selectedPointCallOptions = new FormControl('');
  public readonly selectedPointCallOptions$: BehaviorSubject<ReadonlyArray<FormSelectOption>> = new BehaviorSubject([]);

  public readonly transportAuthorityOptions = new FormControl('');
  public readonly transportAuthorityOptions$ = this._transportAuthorityOptions$;

  public readonly connectionPointCallOptions = new FormControl('');
  public readonly internalConnectionPointCallOptions$ = this._internalConnectionPointCallOptions$.asObservable();
  public readonly externalConnectionPointCallOptions$ = this._externalConnectionPointCallOptions$.asObservable();


  public addVehicleActivity(vehicle: Vehicle, activityPointListItem: ActivityPointListItem[]): void {
    this._vehicleAndactivityPointListItemObject$.next({
      vehicle,
      activityPointListItem,
    });
  }

  public addConnectionVehicleActivity(vehicle: Vehicle, activityPointListItem: ActivityPointListItem[]): void {
    this._connectionVehicleAndactivityPointListItemObject$.next({
      vehicle,
      activityPointListItem,
    });
  }

  public setSelectedTrip(trip: AffectedTrip): void {
    this._selectedTrip$.next(trip);
  }

  public setConnectionCancellationFlow(): void {
    this._isConnectionFlow$.next(true); 
  } 

  public setSelectedConnection(trip: AffectedTrip): void {
    this._selectedConnection$.next(trip);
  }

  public setPointCallOptions(activityPoints: ActivityPoint[], selectedCall: ActivityPoint): void {
    const pointCallOptions = activityPoints.map((p) => ({ 
        text: p.stopDescription,
        value: p.stopId,
        selected: p.stopId === selectedCall?.stopId,
      } as FormSelectOption)
    );
    this.selectedPointCallOptions$.next(pointCallOptions);
    this.selectedPointCallOptions.setValue(selectedCall?.stopId);
  }

  public setConnectionPointCallOptions(activityPoints: ActivityPoint[], selectedCall: ActivityPoint): void {
    const pointCallOptions = activityPoints.map((p) => ({ 
        text: p.stopDescription,
        value: p.stopId,
        selected: p.stopId === selectedCall?.stopId,
      } as FormSelectOption)
    );
    this._internalConnectionPointCallOptions$.next(pointCallOptions);
    this.connectionPointCallOptions.setValue(selectedCall?.stopId);
  }

  public updateSelectedCall(pointCall: ActivityPoint): void {
    this._selectedTrip$.next({
      ...this._selectedTrip$.value,
      selectedPlaceId: pointCall.stopId,
      selectedPlace: pointCall.stopDescription,
    });
  }

  public updateSelectedConnectionCall(pointCall: ActivityPoint): void {
    this._selectedConnection$.next({
      ...this._selectedConnection$.value,
      selectedPlaceId: pointCall.stopId,
      selectedPlace: pointCall.stopDescription,
    });
  }

  public resetTripState(): void {
    this._vehicleAndactivityPointListItemObject$.next(undefined);
    this._connectionVehicleAndactivityPointListItemObject$.next(undefined);
    this._selectedTrip$.next(undefined);
    this._selectedConnection$.next(undefined);
    this._isConnectionFlow$.next(false);
  }
}
